import { jsx as r, jsxs as M, Fragment as k } from "react/jsx-runtime";
import { forwardRef as A } from "react";
import { ButtonStyled as I, LoaderWrapper as h } from "./styles12.mjs";
import { AMPLITUDE_LABEL as P, AMPLITUDE_ACTION as $ } from "./amplitude.mjs";
import { Typography as b } from "./index59.mjs";
import L from "./CircularProgress.mjs";
const t = {
  contained: "primary",
  text: "link",
  primary: "primary",
  outlined: "outlined",
  secondary: "secondary",
  tertiary: "tertiary",
  link: "link"
}, R = {
  xsmall: "TextSm.Medium",
  small: "TextSm.Medium",
  medium: "TextMd.Medium",
  large: "TextMd.Medium"
}, g = () => /* @__PURE__ */ r(L, { color: "inherit", size: 16 }), j = A(
  ({
    isLoading: i = !1,
    testId: m,
    amplitudeLabel: n = P.button,
    amplitudeAction: d = $.click,
    children: p,
    variant: e = "primary",
    color: s = "primary",
    size: o = "medium",
    startIcon: c,
    endIcon: u,
    iconOnly: l = !1,
    linkColor: x = "default",
    ...f
  }, y) => {
    const T = b[R[o]], a = /* @__PURE__ */ r(
      T,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          color: i ? "transparent" : "inherit"
        },
        children: p
      }
    );
    return /* @__PURE__ */ r(
      I,
      {
        ref: y,
        "data-amplitude-label": n,
        "data-amplitude-action": d,
        "data-testid": m,
        startIcon: c,
        endIcon: u,
        $isLoading: i,
        $variant: t[e],
        $color: s,
        $size: o,
        $iconButton: l,
        $linkColor: x,
        ...f,
        disableRipple: t[e] === "link",
        disableFocusRipple: t[e] === "link",
        disableTouchRipple: t[e] === "link",
        children: i ? /* @__PURE__ */ M(k, { children: [
          /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(g, {}) }),
          a
        ] }) : !l && a
      }
    );
  }
);
export {
  j as Button
};
//# sourceMappingURL=index26.mjs.map
